import React from "react";
import { Helmet } from "react-helmet";

import Guardianas1 from "../img/guardianas1.png";
import Guardianas2 from "../img/guardianas2.png";
import Guardianas3 from "../img/guardianas3.png";
import Guardianas4 from "../img/guardianas4.png";
import Guardianas5 from "../img/guardianas5.png";
import Guardianas6 from "../img/guardianas6.png";
import Guardianas7 from "../img/guardianas7.png";
import Guardianas8 from "../img/guardianas8.png";
import Guardianas9 from "../img/guardianas9.png";
import Guardianas10 from "../img/guardianas10.png";
import Guardianas11 from "../img/guardianas11.png";
import Guardianas12 from "../img/guardianas12.png";
import Guardianas13 from "../img/guardianas13.png";
import Guardianas14 from "../img/guardianas14.png";
import Guardianas15 from "../img/guardianas15.png";
import Audio from "../img/audio.mp3";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Fade } from "react-awesome-reveal";
import ReactAudioPlayer from "react-audio-player";

const Guardianas = () => {
  return (
    <div className="page-guardianas">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Guardianas del Agua - Agua e infraestructura natural en el Perú
        </title>
        <meta property="og:title" content="Guardianas del agua" />
        <meta
          name="description"
          content="Serie de reportajes realizados con el fin de generar un mayor debate entre la ciudadanía y los decisores políticos sobre la importancia y eficacia de la infraestructura natural para la gestión sostenible del agua."
        ></meta>
        <meta
          property="og:url"
          content={process.env.REACT_APP_URL + "guardianas-del-agua/"}
        />
        <meta
            property="og:image"
            content="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/comic.jpg"
        />
      </Helmet>
      <div className="">
        <Navbar
          url="https://fundacionmohme.org/especiales/agua-infraestructura-natural-peru/guardianas-del-agua/"
          title="Agua e infraestructura natural en el Perú"
        />
      </div>
      <div className="comic d-flex flex-column align-items-center">
        <ReactAudioPlayer
          alt="Guardianas del agua"
          src={Audio}
          autoPlay
          controls
          controlsList="nodownload"
          className="mb-5"
        />
        <Fade triggerOnce="true" delay="100" duration="1000">
          <img
            alt="Guardianas del agua"
            src={Guardianas1}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true" delay="100">
          <img
            alt="Guardianas del agua"
            src={Guardianas2}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas3}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas4}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas5}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas6}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas7}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas8}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas9}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas10}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas11}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas12}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas13}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas14}
            className="img-fluid mb-5"
          />
        </Fade>
        <Fade triggerOnce="true">
          <img
            alt="Guardianas del agua"
            src={Guardianas15}
            className="img-fluid mb-5"
          />
        </Fade>
      </div>
      <Footer />
    </div>
  );
};

export default Guardianas;
